import { Datatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';
import {
  getComparableNumbers,
  shouldCompareAsNumber,
} from '../utils/numericConditionCoerce.ts';

export const ConditionOperatorGreaterType = createConditionOperator({
  code: 'greaterThan',
  label: '>',
  description: 'Maggiore di',
  args: [{ type: 'referenceValue' }],
  allowsField: field =>
    field.type === Datatype.Number || field.type === Datatype.Date,
  compare(value: any, [amount]: [any], scope, field) {
    if (amount == null) return false;
    if (shouldCompareAsNumber(field, value, amount)) {
      const numbers = getComparableNumbers(value, amount);
      return numbers
        ? numbers.numericValue.greaterThan(numbers.numericTarget)
        : false;
    }
    return value > amount;
  },
});
